import React, { useEffect, useState } from 'react'
import { withStore } from '@bigyellow/store'
import FindUserWithDetails from '@bigyellow/components/SignIn/FindUserWithDetails'
import { getItem } from '@bigyellow/libs/storage'
import { customer_link_reservation } from '@bigyellow/api/customer'
import { handle_api_exception } from '@bigyellow/api/exception'
import VerifyEmailCode from '@bigyellow/components/SignIn/VerifyEmail'
import { email_send } from '@bigyellow/api/register'

const LinkAccount = ({store,OnComplete ,OnCancel}) => {
  const [errors, setErrors] = React.useState([]);
  const [submitting, setSubmitting] = React.useState(false);
  const [verifyEmail, setVerifyEmail] = React.useState(false);
  const [checkinDetails , setCheckinDetails] = React.useState(null);
  const [user, setUser] = React.useState(null);
  const [emailVerificationCode, setEmailVerificationCode] = useState('');

  useEffect(() => {
    getItem('user').then(res => {
      setUser(res);
    });
  }, []);

  const linkAccount=(inCheckinDetails)=> {
    setSubmitting(true);

    const http_client = store
      ? store.get('http_client')
      : null;
    const notify = store.get('notify');

      let reservation_data = {
        email: inCheckinDetails.email,
        customerNumber: inCheckinDetails.customerNumber,
        unitNumber: inCheckinDetails.unitNumber,
      };
      customer_link_reservation(http_client, {userId: user.id, ...reservation_data}).then((res) => {
        OnComplete();
      }).catch(error => {
        let newErrorMessageList = [handle_api_exception(error)];
        setSubmitting(false);
        setErrors(newErrorMessageList);
        notify(handle_api_exception(error), {type: 'error'});
      }).finally(() => {
        setSubmitting(false);
      });
  }


  const sendEmailVerificationCode = (email, customerId) => {
    setSubmitting(true);
    (async () => {
      try {
        const http_client = store.get('http_client');
        const response = await email_send(http_client, { email:email ,customerId:customerId });
        const {debug} = response.data;
        if(debug)
          setEmailVerificationCode(debug?.code);
      } catch (error) {
        const notify = store.get('notify');
        notify(handle_api_exception(error), {type: 'error'});
      }
      finally {
        setSubmitting(false);
      }
    })();
  }

  useEffect(() => {
    if(verifyEmail)
      sendEmailVerificationCode(checkinDetails.email,checkinDetails.customerId);

  },[verifyEmail]);



  if(verifyEmail)
    return <VerifyEmailCode
      email={checkinDetails.email}
      inDebugCode={emailVerificationCode}
      isDisabled={submitting}
      onSendEmailVerificationCode={()=>{
        sendEmailVerificationCode(checkinDetails.email,checkinDetails.customerId);
      }}
      OnSuccess={()=>{
        linkAccount(checkinDetails)

    }}
      OnCancel={()=>{
        setVerifyEmail(false);
      }
    }/>

  return<FindUserWithDetails
    otherErrors={errors}
    searchButtonText="Add storage"
    showCancel={true}
    OnComplete={(code , userData ,checkinDetails)=> {
      if (code === 200) {
        setCheckinDetails(checkinDetails);
        if(user.email === checkinDetails.email) {
          linkAccount({...checkinDetails,customerId:userData.customerId});
        }else
        {
          setVerifyEmail(true);
        }
      }
    }
    }
    OnCancel={OnCancel}
  />

}

export default withStore(LinkAccount);
